import { storageService } from '@/services/storage'

/** Local JSON defaults + localStorage overrides (same pattern as Settings Center). */
export class LocalJsonStore<T> {
  private readonly storageKey: string
  private readonly defaults: T

  constructor(storageKey: string, defaults: T) {
    this.storageKey = storageKey
    this.defaults = defaults
  }

  load(): T {
    if (!storageService.has(this.storageKey)) {
      return structuredClone(this.defaults)
    }
    const stored = storageService.getJSON<T>(this.storageKey, this.defaults)
    return mergeDefaults(this.defaults, stored)
  }

  save(value: T): boolean {
    return storageService.setJSON(this.storageKey, value)
  }

  reset(): T {
    storageService.remove(this.storageKey)
    return structuredClone(this.defaults)
  }
}

function mergeDefaults<T>(defaults: T, stored: T): T {
  if (Array.isArray(defaults)) {
    return (Array.isArray(stored) ? stored : defaults) as T
  }
  if (defaults && typeof defaults === 'object') {
    const base = { ...(defaults as Record<string, unknown>) }
    const overlay = stored && typeof stored === 'object' ? (stored as Record<string, unknown>) : {}
    for (const [key, value] of Object.entries(overlay)) {
      if (value !== undefined) base[key] = value
    }
    return base as T
  }
  return stored ?? defaults
}
